// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/main.css'
import './assets/icon/iconfont.css'
import './assets/fonts/font.css'

import { resetForm } from "@/utils/ruoyi";

ElementUI.Dialog.props.closeOnClickModal.default = false // 全局关闭
Vue.use(ElementUI)
Vue.config.productionTip = false

import VueRouter from "vue-router"

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
    //修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

import RelationGraph from 'relation-graph'
Vue.use(RelationGraph);

// 引入富文本组件
import QuillEditor from 'vue-quill-editor'
// 引入富文本组件样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(QuillEditor)

import VueUeditorWrap from 'vue-ueditor-wrap';
Vue.component('vue-ueditor-wrap', VueUeditorWrap);

//其他省略
Vue.prototype.resetForm = resetForm


import router from './router'
import store from './store'

import "./permission";
// 埋点 SDK 初始化（注入 Vue.prototype.$tracker + SPA 路由 afterEach PV）
import "./analytics/index.js";

//字典 后期考虑数据库字典
import dict from './dict.json';
Vue.prototype.$dict = dict;

// baidu-map
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: 'AdH4dWzuE5vI171dSrvsd9IdoHIqm6CC'
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js